<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div class="text-xs-center">
		<v-dialog
			v-model="dialog"
			width="500">
			<template v-slot:activator="{ on }">
				<v-btn
					color="red lighten-2"
					dark
					@click="openDialog"
					v-on="on">
					Porównaj wersje oferty
				</v-btn>
			</template>
			<v-card>
				<v-card-title
					class="headline"
					primary-title
				>
					Porównywanie wersji
				</v-card-title>

				<v-alert :value="correctionsNotApplied" type="warning" class="ma-3">
					Oferta ma tylko jedną wysłaną wersję.
				</v-alert>

				<v-card-text>
					<v-select label="Późniejsza wersja" @change="selectedSecondVersion" v-model="selected.secondSelected"
						:items="selections.secondItems" aria-label="later version">

					</v-select>
					<v-select label="Wcześniejsza wersja" v-model="selected.firstSelected"
						:items="selections.firstItems"
						aria-label="earlier version">

					</v-select>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						:disabled="correctionsNotApplied"
						color="blue"
						@click="compareLastTwoVersions()"
					>
						Porównaj ostatnie dwie
					</v-btn>
					<v-btn
						:disabled="!selectionEnabled"
						color="primary"
						@click="compareTwoChosenVersions(selected.firstSelected, selected.secondSelected)"
					>
						Porównaj
					</v-btn>
					<v-btn
						color="secondary"
						flat
						@click="closeDialog">
						Zamknij
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	export default {
		name: "CompareOfferVersionsDialog",

		data() {
			return {
				dialog: false,
				selected: {
					firstSelected: null,
					secondSelected: null,
				},
				selections: {
					firstItems: [],
					secondItems: [],
				},
			};
		},

		props: {
			lastVersion: null,
			contestId: null,
      status: {type: String, required: true},
		},

		computed: {
			selectionEnabled() {
				return (this.selected.firstSelected !== null) && (this.selected.secondSelected !== null) && (this.selected.firstSelected < this.selected.secondSelected);
			},

      correctionsNotApplied() {
        return this.lastCompletedVersion < 2;
      },

      // used to exclude non-completed versions from comparison
      lastCompletedVersion() {
        if (this.status === "AWAITING_CORRECTION" || this.status === "POST_CORRECTION_MUTUAL" || this.status === "POST_CORRECTION_MAIN") {
          return this.lastVersion - 1;
        }
        return this.lastVersion;
      }
		},

		methods: {

			compareLastTwoVersions() {
				this.compareTwoChosenVersions(this.lastCompletedVersion - 1, this.lastCompletedVersion);
			},
			compareTwoChosenVersions(first, second) {
				this.$router.openInNewTab(
					"/view/contest/"
						.concat(this.contestId).concat("/compare-offers/")
						.concat(this.$route.params.offerId)
						.concat("/")
						.concat(first)
						.concat("/")
						.concat(second));
			},

			selectedSecondVersion() {
				this.selections.firstItems = Array.from({length: this.selected.secondSelected - 1}, (v, k) => k + 1);
			},

			openDialog() {
				this.dialog = true;
				this.selections.secondItems = Array.from({length: this.lastCompletedVersion}, (v, k) => k + 1);
				this.selections.secondItems.shift();
			},

			closeDialog() {
				this.dialog = false;
			},
		},
	};
</script>

<style scoped>

</style>